<template>
  <div class="partners">
    <form class="head row column-s align-center" onsubmit="return false" @submit="loadPartners(false)">
      <div class="title grid-12-s text-center-s">
        <i class="fa fa-people-carry-box" /> PARCEIROS
      </div>
      <div class="radius row align-center">
        <input type="number" class="input" v-model="distancia" placeholder="Distância" required />
        &nbsp;&nbsp;<b>km</b>
      </div>
      <div class="grid-12-s column autocomplete" @keyup.up="changeActive(--active)"
        @keyup.down="changeActive(++active)">
        <div class="row align-center">
          <input id="city" type="text" class="input" v-model="city.cidade_uf" placeholder="Cidade" @click="mask = true"
            @keyup.enter="getCityID(false)" required />
          <Button class="searchButton" :loader="loader.city" layout="green-go" type="button" @click="getCityID(false)">
            <i class="fa-solid fa-magnifying-glass" />
            &nbsp;Cidade
          </Button>
          <input class="input tecnicos" type="number" placeholder="Nº Técnicos" v-model="tecnicos" />
          <Turnkey :data="turnkey" />
          <Button v-if="!filtro" layout="green-go white" @click="
            filtro = true;
          turnkey.show = true;
          " type="button">
            Aptos?
          </Button>
          <Button v-if="cityID" class="searchButton" :loader="loader.city" layout="green-go" type="submit">
            <i class="fa-solid fa-magnifying-glass" />
            &nbsp;Pesquisar
          </Button>
        </div>

        <ul v-if="autocomplete">
          <li v-for="(item, i) in cities" :key="i + 'op'" :class="active == i && item.cidade && 'active'"
            @click="choice(item)" @mouseenter="active = i" @keyup.enter="choice(item)" :tabIndex="i" :id="'city' + i">
            <i class="fa fa-location-dot" /> {{ item.cidade_uf }}
          </li>
        </ul>
        <transition name="fade">
          <div v-if="mask" class="mask" @click="
            mask = false;
          autocomplete = false;
          " />
        </transition>
      </div>
    </form>

    <div v-if="show" class="row column-s">
      <div class="column grid-6 grid-12-s">
        <div class="resume row align-center justify-around wrap-s">
          <div class="grid-2 column text-center">
            <label>SUPPORTERS</label>
            {{ resume.supporter.doutores || 0 }} |
            {{ resume.supporter.doutores_aptos || 0 }} aptos
          </div>
          <div class="grid-2 column text-center">
            <label>NA CIDADE</label>
            {{ resume.supporter.doutores_cidade || 0 }} |
            {{ resume.supporter.doutores_aptos_cidade || 0 }} aptos
          </div>
          <div class="grid-2 column text-center">
            <label>OUTRAS CIDADES</label>
            {{ resume.supporter.doutores_outras_cidades || 0 }} |
            {{ resume.supporter.doutores_aptos_outras_cidades || 0 }} aptos
          </div>
          <div class="grid-2 column text-center">
            <label>TÉCNICOS SUPPORTER</label>
            {{ resume.supporter.tecnicos_doutores || 0 }} |
            {{ resume.supporter.tecnicos_doutores_aptos || 0 }} aptos
          </div>

          <div class="grid-2 column text-center">
            <label>NA CIDADE</label>
            {{ resume.supporter.tecnicos_doutores_cidade || 0 }} |
            {{ resume.supporter.tecnicos_doutores_aptos_cidade || 0 }} aptos
          </div>
          <div class="grid-2 column text-center">
            <label>OUTRAS CIDADES</label>
            {{ resume.supporter.tecnicos_doutores_outras_cidades || 0 }} |
            {{ resume.supporter.tecnicos_doutores_aptos_outras_cidades || 0 }} aptos
          </div>
        </div>

        <div class="list column">
          <template v-if="!loader.enable">
            <div class="row justify-space align-center">
              <div class="title">
                Supporters em <label>{{ city.cidade_uf }}</label>
              </div>

              <input class="input search" type="text" v-model="enableSearch" placeholder="Procurar"
                v-if="!notFound.supporter && partners.enable.length" />
              <!--  <div v-else class="notfound">Nenhum Supporter encontrado.</div> -->
            </div>
            <CardSupporterPartner :data="cardSupporterPartner" />
            <div v-if="!notFound.supporter && partners.enable.length" class="labels row">
              <div class="grid-1">Distância</div>
              <div class="grid-3 hide-s">Cidade/UF</div>
              <div class="grid-3">Nome</div>
              <div class="grid-1">Apto</div>
              <div class="grid-1">Técnicos</div>
              <div class="grid-1">Pendências</div>
              <div class="grid-2 tc">Cadastro</div>
            </div>
            <div class="enableMask">
              <div class="enable row" v-for="(part, i) of filteredEnabledPartners" :key="'enable' + i"
                @click="detailSupporter(part)">
                <div class="grid-1">
                  {{ part.distancia }}
                </div>
                <div class="grid-3 hide-s">
                  {{ part.cidade }}
                </div>
                <div class="grid-3">
                  {{ part.nome }}
                </div>
                <div class="grid-1">
                  {{ part.apto ? "Sim" : "Não" }}
                </div>
                <div class="grid-1 text-center">
                  {{ part.tecnicos }}
                </div>
                <div class="grid-1 text-center">
                  {{ part.pendencias }}
                </div>
                <div class="grid-2 text-center">
                  {{ part.status_cadastro }}
                </div>
              </div>
            </div>
          </template>
          <Loader layout="small" v-else />
        </div>
      </div>

      <div class="column grid-6 grid-12-s">
        <div class="resume row align-center justify-around wrap-s">
          <div class="grid-2 column text-center">
            <label>PARCEIROS</label>
            {{ resume.partner.parceiros || 0 }} |
            {{ resume.partner.parceiros_aptos || 0 }} aptos
          </div>

          <div class="grid-2 column text-center">
            <label>NA CIDADE</label>
            {{ resume.partner.parceiros_cidade || 0 }} |
            {{ resume.partner.parceiros_aptos_cidade || 0 }} aptos
          </div>
          <div class="grid-2 column text-center">
            <label>OUTRAS CIDADES</label>
            {{ resume.partner.parceiros_outras_cidades || 0 }} |
            {{ resume.partner.parceiros_aptos_outras_cidades || 0 }} aptos
          </div>

          <div class="grid-2 column text-center">
            <label>TÉCNICOS PARCEIROS</label>
            {{ resume.partner.tecnicos_parceiros || 0 }} |
            {{ resume.partner.tecnicos_parceiros_aptos || 0 }} aptos
          </div>

          <div class="grid-2 column text-center">
            <label>NA CIDADE</label>
            {{ resume.partner.tecnicos_parceiros_cidade || 0 }} |
            {{ resume.partner.tecnicos_parceiros_aptos_cidade || 0 }} aptos
          </div>
          <div class="grid-2 column text-center">
            <label>OUTRAS CIDADES</label>
            {{ resume.partner.tecnicos_parceiros_outras_cidades || 0 }} |
            {{ resume.partner.tecnicos_parceiros_aptos_outras_cidades || 0 }} aptos
          </div>
        </div>
        <div class="list column">
          <template v-if="!loader.selected">
            <div class="row justify-space align-center">
              <div class="title">
                Parceiros em <label>{{ city.cidade_uf }}</label>
              </div>

              <input class="input search" type="text" v-model="partnersSearch" placeholder="Procurar"
                v-if="!notFound.partners && partners.selected.length" />
              <!-- <div v-else class="notfound">Nenhum Parceiro encontrado.</div> -->
            </div>
            <CardPartner :data="cardPartner" />
            <div v-if="!notFound.partners && partners.selected.length" class="labels row">
              <div class="grid-1">Distância</div>
              <div class="grid-3 hide-s">Cidade/UF</div>
              <div class="grid-3">Nome</div>
              <div class="grid-1">Apto</div>
              <div class="grid-1">Técnicos</div>
              <div class="grid-1">Pendências</div>
              <div class="grid-2 tc">Cadastro</div>
            </div>
            <div class="enableMask">
              <div class="enable row" v-for="(part, i) of filteredPartners" :key="'enable' + i"
                @click="detailPartner(part)">
                <div class="grid-1">
                  {{ part.distancia }}
                </div>
                <div class="grid-3 hide-s">
                  {{ part.cidade }}
                </div>
                <div class="grid-3">
                  {{ part.nome }}
                </div>
                <div class="grid-1">
                  {{ part.apto ? "Sim" : "Não" }}
                </div>
                <div class="grid-1 text-center">
                  {{ part.tecnicos }}
                </div>
                <div class="grid-1 text-center">
                  {{ part.pendencias }}
                </div>
                <div class="grid-2 text-center">
                  {{ part.status_cadastro }}
                </div>
              </div>
            </div>
          </template>
          <Loader layout="small" v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";
import Turnkey from "@/components/Turnkey.vue";
import CardPartner from "@/components/CardPartner.vue";
import CardSupporterPartner from "@/components/CardSupporterPartner.vue";

export default {
  name: "Partners",
  components: { Loader, Turnkey, CardPartner, CardSupporterPartner, Button },
  data() {
    return {
      tecnicos: "",
      show: false,
      loader: {
        city: false,
        enable: true,
        selected: true,
      },
      resume: {
        supporter: {},
        partner: {},
      },
      mask: false,
      cities: [],
      active: 0,
      city: { cidade_uf: "" },
      distancia: "",
      partners: {
        enable: [],
        selected: [],
      },
      cityID: null,
      autocomplete: false,
      enableSearch: "",
      partnersSearch: "",
      cardPartner: {},
      cardSupporterPartner: {},
      notFound: {
        supporter: false,
        partners: false,
      },
      filtro: false,
      turnkey: {
        show: false,
        on: false,
        label: { on: "Aptos", off: "Não aptos" },
        close: () => {
          this.turnkey.show = false;
          this.filtro = false;
        },
        toggle: () => (this.turnkey.on = !this.turnkey.on),
      },
    };
  },

  methods: {
    ...mapActions("admin", [
      "PARTNERS_ENABLE",
      "PARTNERS_ADD",
      "PARTNERS_POST",
      "PARTNERS_REMOVE",
      "SUPPORTER_INFO",
      "PARTNERS_INFO",
      "PARTNERS_ADD_CLIENT",
      "PARTNERS_REMOVE_CLIENT",
    ]),
    ...mapActions("general", ["LOAD_CITIES"]),
    detailSupporter(part) {
      this.cardSupporterPartner = {
        ...part,
        show: true,
        close: () => (this.cardSupporterPartner.show = false),
        loader: true,
        action: () => {
          this.cardSupporterPartner.loader = true;
          this.PARTNERS_ADD({
            id_doutor: part.id_doutor,
            id_cidade: this.cityID,
            etag: this.city.etag,
          })
            .then(() => {
              this.cardSupporterPartner.loader = false;
              this.cardSupporterPartner.show = false;
              this.getCityID(true);
            })
            .catch(() => (this.cardSupporterPartner.loader = false));
        },
      };

      this.SUPPORTER_INFO({
        id_doutor: part.id_doutor,
        id_cidade: this.cityID,
      }).then(({ data }) => {
        this.cardSupporterPartner = {
          ...this.cardSupporterPartner,
          ...data,
          loader: false,
        };
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    },
    load_partner(part) {
      this.PARTNERS_INFO({
        id_doutor: part.id_doutor,
        id_cidade: this.cityID,
      }).then(({ data }) => {
        this.cardPartner = {
          ...this.cardPartner,
          ...data,
          loader: false,
        };
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    },
    detailPartner(part) {
      this.cardPartner = {
        ...part,
        show: true,
        loader: false,
        close: () => (this.cardPartner.show = false),
        action: (ID) => {
          this.cardPartner.loader = true;
          this.PARTNERS_ADD_CLIENT({
            id_doutor: part.id_doutor,
            id_cidade: this.cityID,
            id_cliente: ID,
            etag: this.city.etag,
          })
            .then(() => {
              this.cardPartner.loader = false;
              this.load_partner(part);
              this.getCityID(true);
            })
            .catch(() => (this.cardPartner.loader = false));
        },
        remove: () => {
          if (confirm("Deseja remover " + part.nome + " dos Parceiros?")) {
            this.cardPartner.loader = true;
            this.PARTNERS_REMOVE({
              id_doutor: part.id_doutor,
              id_cidade: this.cityID,
              etag: this.city.etag,
            })
              .then(() => {
                this.cardPartner.loader = false;
                this.cardPartner.show = false;
                this.partners.selected = this.partners.selected.filter(
                  (s) => s.id_doutor != part.id_doutor
                );
                this.getCityID(true);
              })
              .catch(() => (this.cardPartner.loader = false));
          }
        },
        removeClient: (client) => {
          if (confirm("Deseja remover " + client.cliente + " deste Parceiro?")) {
            this.PARTNERS_REMOVE_CLIENT({
              id_doutor: part.id_doutor,
              id_cidade: this.cityID,
              id_cliente: client.id_cliente,
              etag: this.city.etag,
            }).then(({ status }) => {
              this.cardPartner.clientes = this.cardPartner.clientes.filter(
                (c) => c.id_cliente != client.id_cliente
              );
              if (status == 200) this.getCityID(true);
            });
          }
        },
      };
      this.load_partner(part);
    },
    getCityID(reload) {
      if (this.city.cidade_uf.length > 1) {
        this.cities = [];
        this.autocomplete = false;
        this.loader.city = true;

        this.LOAD_CITIES({ cidade: `${this.city.cidade_uf}` })
          .then(({ data }) => {
            this.cities = data;
            if (!reload) {
              this.active = 0;
              this.autocomplete = true;
              this.mask = true;
              setTimeout(function () {
                let select = document.getElementById("city0");
                if (select) {
                  select.blur();
                  select.focus();
                }
              }, 300);
            } else {
              this.loadPartners(data[this.active]);
            }
            this.loader.city = false;
          })
          .catch(() => {
            this.cities.push({ cidade_uf: "Nenhuma cidade encontrada" });
            this.autocomplete = true;
            this.loader.city = false;
          });
      } else {
        alert("A cidade tem que ter no minímo duas letras.");
      }
    },
    changeActive() {
      if (this.active == -1) this.active = 0;
      if (this.active == this.cities.length && this.cities.length != 1) this.active--;
      if (this.active == this.cities.length && this.cities.length == 1) this.active = 0;
      let select = document.getElementById("city" + this.active);
      if (select) {
        select.blur();
        select.focus();
      }
    },
    choice(city) {
      this.cityID = city.id;
      this.city = city;
      this.autocomplete = false;
      this.mask = false;
    },
    loadPartners(city) {
      this.show = true;
      if (city) {
        this.cityID = city.id;
        this.city = city;
      }
      this.loader.enable = true;
      this.loader.selected = true;
      this.notFound.supporter = false;
      this.notFound.partners = false;
      this.partners.partner = [];
      this.partners.enable = [];

      let payload = { id_cidade: this.cityID, distancia: parseInt(this.distancia) };

      if (this.filtro) payload.apto = this.turnkey.on;
      else delete payload.apto;

      if (this.tecnicos && this.tecnicos !== null && this.tecnicos.length)
        payload.tecnicos = parseInt(this.tecnicos);
      else delete payload.tecnicos;

      this.PARTNERS_ENABLE(payload)
        .then(({ data: { dados, resumo } }) => {
          if (dados) {
            this.resume.supporter = resumo;
            this.partners.enable = dados.doutores;
          } else {
            this.notFound.supporter = true;
          }
          this.loader.enable = false;
        })
        .catch(() => {
          this.notFound.supporter = true;
          this.loader.enable = false;
        });

      this.PARTNERS_POST(payload)
        .then(({ data: { dados, resumo } }) => {
          if (dados) {
            this.resume.partner = resumo;
            this.partners.selected = dados.parceiros;
          } else {
            this.notFound.partners = true;
          }
          this.loader.selected = false;
        })
        .catch(() => {
          this.notFound.partners = true;
          this.loader.selected = false;
        });
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("partners");
  },
  computed: {
    ...mapGetters("admin", ["clients"]),

    filteredEnabledPartners() {
      if (this.enableSearch) {
        const search = this.enableSearch.toLowerCase();

        return this.partners.enable.filter((part) => {
          let partsSerialize = JSON.stringify(part).toLowerCase();
          return partsSerialize.includes(search);
        });
      } else {
        return this.partners.enable;
      }
    },
    filteredPartners() {
      if (this.partnersSearch) {
        const search = this.partnersSearch.toLowerCase();

        return this.partners.selected.filter((part) => {
          const partsSerialize = JSON.stringify(part).toLowerCase();
          return partsSerialize.includes(search);
        });
      } else {
        return this.partners.selected;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.partners
  padding: 42px 35px
  @media (max-width: $small)
    padding: 7px
  .head
    .title
      font-size: 29px
      font-weight: bold
      color: $gray-4
      text-transform: uppercase
      margin-right: 40px
      @media (max-width: $small)
        margin: 30px
        .fa
          font-size: 33px
    .tecnicos
      width: 100px !important
      margin-left: 12px
    .searchButton
        z-index: 610
        height: 50px
        margin-left: 16px
    .turnkey, .white
      z-index:610
      margin-left: 12px
      height: 50px
    .autocomplete
      @media (min-width: $small)
        margin-left: 21px
        margin-top: -9px
      input
        z-index: 610
        &:focus
          color: white
        @media (min-width: $medium)
          width: 600px
        @media (max-width: $small)
          margin: 0 5%
          width: 90%
      .loader
        margin-left: -39px
        margin-right: 11px
        z-index: 610
        @media (max-width: $small)
          margin-left: -70px
      ul
        padding-top: 12px
        margin-top: 61px
        position: absolute
        background: white
        border-radius: 19px
        overflow: hidden
        z-index: 610
        max-height: 190px
        overflow-y: auto
        @include border
        @media (min-width: $medium)
          width: 615px
        @media (max-width: $small)
          width: 90%
          margin:60px 5%
      li
        padding: 15px 9px
        font-size: 14px
        &:hover, &.active
          background: $supporter-1
          color: white
          cursor: pointer
        &:hover
          background: $supporter-1
        &:focus
          outline: none
        i
          font-size: 12px

      .mask
        @include mask

    .radius
      z-index: 610
      b
        color: $supporter-1

      @media (max-width: $small)
          margin: 30px
      input
        margin-top: -9px
        margin-left: 15px
        width: 80px
        &:focus
          color: white
  .resume
    font-weight: bold
    padding: 0 9px
    color: #333
    font-size: 13px
    background: #f9f9f9
    border-radius: 19px 19px 0 0
    height: 88px
    margin-right: 20px
    margin-left: 9px
    margin-top: 41px
    margin-bottom: 0px
    label
      margin-top: -8px
      margin-bottom: 6px
      color: $client-2
      font-size: 9px
      font-weight: bold
  .list
    background: white
    margin-right: 12px
    border-radius: 21px
    margin-top: -10px
    height: 400px
    padding: 23px
    @include border
    @media (max-width: $small)
      margin: 19px 5%
    .loader
      margin: auto
      margin-top: 120px
    .title
      font-size: 19px
      line-height: 26px
      label
        color: $label
    .notfound
      font-size: 14px
      color: $orange
    .input
      height: 40px
      border-bottom: 1.9px solid #999
      box-shadow: none
      border-radius: 0
      &:focus
        border-bottom: 1.9px solid $supporter-1
        color: $supporter-1
        background: none
    .search
      width: 90%
    .labels
      margin-top: 40px
      color: $supporter-1
      font-size: 13px
      height: 35px
      @media (max-width: $medium)
        font-size: 12px
    .enableMask
      height: 300px
      overflow-y: auto
      .enable
        padding: 13px 3px
        font-size: 13px
        @media (max-width: $medium)
          font-size: 13px
          padding: 15px 9px
        &:hover
          background: $supporter-1
          color: white
          cursor: pointer
          border-radius: 19px
</style>
